import {Component, ComponentOptions, LayoutOptions} from "@mecatran-components/component";
import {SearchBox} from "@mecatran-components/searchbox";
import {Input} from "@mecatran-components/input";



export class OriginDestination extends Component{
    constructor(odOptions){
        var odOptions = odOptions || {};
        var componentOptions = new ComponentOptions();
        componentOptions.setDomOptions(odOptions.domOptions);
        super(componentOptions);
        var orDestArray = ['origin','destination'];

        Object.defineProperty(this,'orDestArray',{
            get: ()=>orDestArray
        })

        this.initOriginDestinationComponent(odOptions);
    }

    // ==========
    // private 
    // ----------

    getOriginComponent(){
        return this.getStorageManager().getComponents('origin')[0];
    }

    getDestinationComponent(){
        return this.getStorageManager().getComponents('destination')[0];
    }

    getReverseComponent(){
        return this.getStorageManager().getComponents('reverse')[0];
    }

    isReverseButton(element){ return element.classList.contains('reverse'); }

    onReverseButtonClick(e){
       var originSearchBox = this.getOriginComponent();
       var destinationSearchBox = this.getDestinationComponent();
       var tmp = destinationSearchBox.getValue();
       destinationSearchBox.setValue(originSearchBox.getValue());
       originSearchBox.setValue(tmp);
       this.emitCustomEvent('reverseEvent');
    }

    onClick(event){
        var element = event.target;
        //console.log('element type', element.dataset.type)
        var isClear = element.classList.contains('clear'); 
        var isReverse = element.classList.contains('reverse');
        var type;
        if (isReverse){
            type ='reverse';
        } else{
            type = (isClear) ? `clear-` : '';
            var searchBox = element.closest('.search-box');
            var index = this.getDomManager().getElementIndex(searchBox, '.search-box');
            if (index < 0) return; 
            if (index < 2 && index >= 0) type += this.orDestArray[index]; 
        }
        console.log('=========>',type)
        this.emitCustomEvent('clickEvent',type);
    }


    initOriginDestinationComponent(odOptions){
        var origSBOptions = odOptions.origin || {};
        origSBOptions.clearButtonUrl = "./assets/cross.svg";
        origSBOptions.label = "Departure";
        origSBOptions.domOptions = { id : 'origin' , classList : ['search-box']}
        origSBOptions.inputOptions = Object.assign({ classList : ['search'] }, origSBOptions.inputOptions);
        var originSearchBox = new SearchBox(origSBOptions);
        this.addSubComponent(originSearchBox,'origin','.search-boxes');
        

        var destSBOptions = odOptions.destination || {};
        destSBOptions.clearButtonUrl = "./assets/cross.svg";
        destSBOptions.label = "Arrival";
        destSBOptions.domOptions = { id : 'destination' , classList : ['search-box']}
        destSBOptions.inputOptions = { classList : ['search']}
        var destSearchBox = new SearchBox(destSBOptions);
        this.addSubComponent(destSearchBox,'destination','.search-boxes');


        var reverseButton = new Input({ 
            src  : './assets/reverse.svg',
            classList :  ['reverse'],
            style : { 'vertical-align': 'middle'},
            id : 'reverse'
        });
        this.addSubComponent(reverseButton,'reverse');

        this.build();
    }

    // ==========
    // overloaded
    // ----------
    createContainerNode(domOptions){
        var div = document.createElement('div');
        div.classList.add('origin-destination');
        OriginDestination.setDomOptions(div,domOptions)
        return div;
    } 

    createContentNode(context){
        var searchBoxes = document.createElement('div');
        searchBoxes.classList.add('search-boxes');
        return searchBoxes;
    }


    defineEventListeners(eventManager){
        eventManager.on('click', this.isReverseButton, this.onReverseButtonClick.bind(this), false);
        eventManager.on('click', ()=>true, this.onClick.bind(this), false);
    };

    

    // ==========
    // public
    // ----------
    setOriginValue(value){
        this.getOriginComponent().setValue(value);
    }

    setDestinationValue(value){
        this.getDestinationComponent().setValue(value);
    }

    getValue(prop){
        switch(prop){
            case 'origin':
                return this.getOriginComponent().getValue();
                break;
            case 'destination':
                return this.getDestinationComponent().getValue();
                break;
        }       
    }

    setValue(prop,value){
        switch(prop){
            case 'origin':
                this.setOriginValue(value);
                break;
            case 'destination':
                this.setDestinationValue(value);
                break;
        }
    }



    // ==========
    // static
    // ----------
    static setDomOptions(node, domOptions){
        var domOptions = domOptions || {};
        if (domOptions.style){
            var strStyle = OriginDestination.serializeObject(domOptions.style); 
            node.setAttribute('style',strStyle)
        }
        if (domOptions.classList) domOptions.classList.forEach(className => node.classList.add(className));
        if (domOptions.id) node.setAttribute('id',domOptions.id);
    }

    static serializeObject(object){
        var str = '';
        Object.entries(object).forEach(([k,v])=> str+= `${k}:${v}`)
        return str;
    }



}

/**
 * interface OriginDestinationOptions 
 * origin : searchBoxOptions  
 * domOptions : domOptions 
 */
class OriginDestinationOptions{}